import { Pipe, PipeTransform } from '@angular/core';
import { formatStoredPhone } from '../data/phone-format';

/** Exibe o telefone armazenado: BR em formato nacional, demais países em formato internacional. */
@Pipe({
    name: 'phone',
    standalone: true
})
export class PhonePipe implements PipeTransform {
    transform(value: string): string {
        if (!value || typeof value !== 'string') {
            return value;
        }

        return formatStoredPhone(value);
    }
}
